import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const productRoutes = [
  <Route
    key="bootcamp"
    exact
    path="/bootcamp"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/products/Bootcamp")}
      />
    )}
  />,
  <Route
    key="buku-online"
    exact
    path="/buku-online"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/products/BukuOnline")}
      />
    )}
  />,
  <Route
    key="masukapoteker"
    exact
    path="/masukapoteker"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/products/Masukapoteker")}
      />
    )}
  />,
  <Route
    key="ukmppai"
    exact
    path="/ukmppai"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/products/Ukmppai")}
      />
    )}
  />,
  <Route
    key="ukomttk"
    exact
    path="/ukomttk"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/products/Ukomttk")}
      />
    )}
  />,
  <Route
    key="tryout"
    exact
    path="/tryout"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/products/Tryout")}
      />
    )}
  />,
  <Route
    key="buku"
    exact
    path="/buku"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Buku")}
      />
    )}
  />,
  <Route
    key="beasiswa-obatukai"
    exact
    path="/beasiswa-obatukai"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/FreeTrial")}
      />
    )}
  />
];

export default productRoutes; 